import styled from 'styled-components';

export const Spacer = styled.div`
  background-color: transparent;
  height: 24px;
`;
